// extracted by mini-css-extract-plugin
export default {"fluid-container":"_17v5mid","fluidContainer":"_17v5mid","fluid-container-wide":"_k155rf","fluidContainerWide":"_k155rf"};